import React, { useEffect, useState, useRef } from 'react';
import './pp.css';
import { useForm } from '../../hooks/useForm';
import { useAxiosPost } from '../../hooks/useSuscribir';
import { useTranslation } from 'react-i18next';

const PopupBooks = ({
  imgTemp,
  titleLeft,
  titleRigth,
  visible,
  setVisible
}) => {

  const [t] = useTranslation('global');

  const dialogRef = useRef(null);

  const [formSubmitted, setFormSubmitted] = useState(false);

  const {
    formState,
    onInputChange,
    name,
    lastName,
    email,
    onResetForm
  } = useForm({
    name: '',
    lastName: '',
    email: ''
  });

  const { data, isLoading, error } = useAxiosPost(
    formSubmitted
      ? 'https://www.ricardosalinas.com/S8JFmpfeLW5iUVROXz2owTPU/api/subscriber'
      : null,
    {
      subject: "¡Gracias por suscribirte al blog!",
      message: "Ahora puedes descargar el fragmento en el sig link",
      assets: "https://www.ricardosalinas.com/content/assets/img/libros/Mailing-Warmup12092022.jpg",
      isFeedback: true,
      url: "https://www.ricardosalinas.com/libro_negocios/descarga",
      name,
      lastName,
      email,
      origin: "Libro azul"
    },
    setFormSubmitted
  );

  useEffect(() => {
    if (visible) {
      dialogRef.current?.showModal();
    } else {
      dialogRef.current?.close();
    }
  }, [visible]);

  useEffect(() => {
    if (data === undefined) {
      onResetForm();
    }
  }, [data]);

  const onFormSubmit = (event) => {
    event.preventDefault();

    if (
      name.length <= 1 ||
      lastName.length <= 1 ||
      email.length <= 1
    ) {
      return;
    }

    setFormSubmitted(true);

    alert(t("pop-up.gracias"));

    setTimeout(() => {
      dialogRef.current?.close();
      setVisible(false);
    }, 700);
  };

  return (
    <dialog ref={dialogRef} className="write-me-modal">

      <section className="write-me-modal__panel">

        {/* CERRAR */}
        <button
          type="button"
          className="write-me-modal__close"
          onClick={() => {
            dialogRef.current?.close();
            setVisible(false);
          }}
        >
          ✕
        </button>

        <form
          className="write-me-modal__form"
          onSubmit={onFormSubmit}
          autoComplete="off"
        >

          <div className="write-me-modal__body">

            <h2 className="write-me-modal__title">
              {titleLeft}
            </h2>

            {/*
                        <p className="write-me-modal__subtitle">
                            {titleRigth}
                        </p>

                         IMAGEN 
                        {
                            imgTemp && (
                                <img
                                    src={imgTemp}
                                    alt="Popup"
                                    className="write-me-modal__image"
                                />
                            )
                        }*/}

            {/* NOMBRE */}
            <label className="write-me-modal__field">
              <span className="write-me-modal__field-label">
                {t('forms.name')}*
              </span>

              <input
                type="text"
                name="name"
                value={name}
                onChange={onInputChange}
                className="write-me-modal__field-control"
                required
              />
            </label>

            {/* APELLIDO */}
            <label className="write-me-modal__field">
              <span className="write-me-modal__field-label">
                {t('forms.last_name')}*
              </span>

              <input
                type="text"
                name="lastName"
                value={lastName}
                onChange={onInputChange}
                className="write-me-modal__field-control"
                required
              />
            </label>

            {/* EMAIL */}
            <label className="write-me-modal__field">
              <span className="write-me-modal__field-label">
                {t('forms.email')}*
              </span>

              <input
                type="email"
                name="email"
                value={email}
                onChange={onInputChange}
                className="write-me-modal__field-control"
                required
              />
            </label>

            {/* BOTÓN */}
            <button
              type="submit"
              className="write-me-modal__submit"
            >
              {
                isLoading
                  ? t('forms.sending')
                  : t('general.suscribirse')
              }
            </button>

          </div>
        </form>
        <p class="write-me-modal__legal book-legal">Al suscribirte aceptas ser contactado a través de esta dirección de correo electrónico y el aviso de privacidad</p>
      </section>
    </dialog>
  );
};

export default PopupBooks;